import { CurrentUserEntriesAndStats } from 'components/dashboard/entries-and-stats/EntriesAndStats';
import HeaderProfile from 'components/dashboard/header-profile/HeaderProfile';
import MainLayout from 'components/layout/MainLayout';
import { useAuthRedirectEffect } from 'hooks/account/useAuthRedirect';
import { usePlayerInvitesAndInvitees } from 'hooks/referrals/usePlayerInvitesAndInvitees';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DashboardInstagramFeed } from 'components/dashboard/DashboardInstagramFeed';
import DashboardLinks from 'components/dashboard/DashboardLinks';
import { MoreWaysToWin } from 'components/dashboard/MoreWaysToWin';
import { CurrentUserTreeProgression } from 'components/dashboard/TreeProgression';
import WinsAndMonthly from 'components/dashboard/WinsAndMonthly';

import YourReferrals from 'components/dashboard/your-referrals/YourReferrals';
import { CurrentUserYourWishlist } from 'components/dashboard/your-wishlist/YourWishlist';
import { useReferralsSharedWins } from 'hooks/referrals/useReferralsSharedWins';
import { useUserStore } from 'hooks/stores/useUserStore';
import styles from './dashboard.module.css';

interface Dashboard2026Props {}

const Dashboard2026 = observer((_props: Dashboard2026Props) => {
  useAuthRedirectEffect('/dashboard');
  const [dashboardLoading, setDashboardLoading] = useState(true);
  const { currentUser, isInMonthlyRaffle } = useUserStore();
  const {
    invitees,
    referrerName,
    referrerAvatarUrl,
    loading: referralPlayersLoading,
  } = usePlayerInvitesAndInvitees();

  const sharedWins = useReferralsSharedWins();

  useEffect(() => {
    if (dashboardLoading) {
      setTimeout(() => {
        setDashboardLoading(false);
      }, 1000);
    }
  }, [dashboardLoading]);

  return (
    <MainLayout limitItemWidths noHeaderDropShadow footerBackground="teal">
      <div className={`daymadeTypographyReset ${styles.outerContainer}`}>
        {/* PROFILE INFO & EDIT PROFILE */}
        <HeaderProfile loading={dashboardLoading} />
        {/* ENTRIES & STATS */}
        <CurrentUserEntriesAndStats
          loading={dashboardLoading || referralPlayersLoading}
          referrerName={referrerName}
        />
        {/* YOUR WINS & MONTHLY 10k */}
        <WinsAndMonthly
          loading={dashboardLoading}
          showMonthly10kGiveaway={isInMonthlyRaffle}
        />
        {/* MORE WAYS TO WIN (TOKEN TOWN DRAWS) */}
        <MoreWaysToWin loading={dashboardLoading} />

        {/* TREES & WISHLIST */}
        {!dashboardLoading && (
          <AboutUsModule background="grey" withReducedPadding>
            <AboutUsSiteContainer overlapAbove twoColumn>
              <div className={styles.dashboardReferralsContainer}>
                {currentUser && (
                  <YourReferrals
                    loading={dashboardLoading || referralPlayersLoading}
                    winsShared={sharedWins?.length ?? 0}
                    referrerName={referrerName}
                    referrerAvatar={referrerAvatarUrl}
                    referees={invitees}
                  />
                )}
              </div>
              <div className={styles.dashboardTreeContainer}>
                <CurrentUserTreeProgression />
              </div>
            </AboutUsSiteContainer>
          </AboutUsModule>
        )}

        {/* WISHLIST */}
        {!dashboardLoading && (
          <AboutUsModule background="grey" withReducedPadding>
            <AboutUsSiteContainer>
              <CurrentUserYourWishlist desktopPrizesDirection="row" />
            </AboutUsSiteContainer>
          </AboutUsModule>
        )}

        {/* INSTAGRAM FEED */}
        <DashboardInstagramFeed loading={dashboardLoading} />

        {/* LINKS */}
        <DashboardLinks loading={dashboardLoading} />
      </div>
    </MainLayout>
  );
});

export default Dashboard2026;
